angular.module('shared-components.popup.client', [
  'shared-components.popup',
  'data.client'
]);